import React, { useState, useEffect, useRef } from 'react';
import { faSparkles } from '@fortawesome/pro-solid-svg-icons';
import { faSparkles as faSparklesRegular } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge, ListGroup, OverlayTrigger, Popover } from 'react-bootstrap-5';
import { faLink } from '@fortawesome/pro-solid-svg-icons';

export default function AiBadge({ sources, verified }: { sources: string[], verified: boolean }) {
  const [showPopover, setShowPopover] = useState(false);
  const badgeRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const target = event.target;
      const popoverElement = document.getElementById('ai-popover');
      const clickedInsidePopover = popoverElement?.contains(target);
      const clickedInsideBadge = badgeRef.current?.contains(target);

      if (showPopover && !clickedInsidePopover && !clickedInsideBadge) {
        setShowPopover(false);
      }
    };

    if (showPopover) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showPopover]);

  const popover = (
    <Popover
      className="border-0"
      id="ai-popover"
      style={{ minWidth: 300 }}
      onMouseLeave={() => setShowPopover(false)}
    >
      <Popover.Body className="p-0">
        <div className="fw-bold py-1 px-2 rounded-top bg-light">
          <FontAwesomeIcon className="me-2 icon-gradient" icon={faSparklesRegular} />
          AI {verified ? 'Verified' : 'Sourced'}
        </div>
        <div className="p-2">
          <p>
            AI research found this contact in various public records and other sources{sources.length == 0 ? '.' : ':'}
          </p>
          {sources.length > 0 && (
            <ListGroup>
              {sources.map(source => (
                <ListGroup.Item
                  action
                  className="d-flex flex-grow-1"
                  key={source}
                >
                  <a
                    className="text-truncate"
                    href={source}
                    rel="noopener noreferrer"
                    target="_blank"
                    onClick={e => e.stopPropagation()}
                  >
                    <FontAwesomeIcon className="me-2" icon={faLink} />
                    {source}
                  </a>
                </ListGroup.Item>
              ))}
            </ListGroup>
          )}
        </div>
      </Popover.Body>
    </Popover>
  );

  return (
    <div ref={badgeRef}>
      <OverlayTrigger
        container={document.body}
        overlay={popover}
        placement="auto"
        show={showPopover}
        trigger="click"
        onToggle={() => setShowPopover(!showPopover)}
      >
        <Badge bg="" className="badge-gradient badge-sm py-0-5" style={{ cursor: 'pointer' }}>
          <FontAwesomeIcon icon={faSparkles} size="xs" />
          <span className="fs-x-small">AI {verified ? 'Verified' : 'Sourced'}</span>
        </Badge>
      </OverlayTrigger>
    </div>
  );
}
